import React, { memo } from "react";

import { Localized } from "fluent-react/compat";

const InformUserCart = memo(({ totalPrice, redirectCart, currency }) => {
  return (
    <div
      className="container-inform-user-cart animated slideInUp"
      onClick={redirectCart}
    >
      <span>
        <Localized id="tr-display-my-cart" />
      </span>
      <span>{totalPrice} {currency}</span>
    </div>
  );
});

export default InformUserCart;
